import React, { ReactElement } from "react";
import ReactDOM from "react-dom";

import DialogOverlay from "./DialogOverlay";

const dialogRoot = document.getElementById("dialog-root");

interface IProps {
  onClose?: () => void;
  children: ReactElement;
}

export default function DialogPortal({ children, onClose }: IProps) {
  if (!dialogRoot) {
    return <>{children}</>;
  }
  return ReactDOM.createPortal(
    <DialogOverlay children={children} onClose={onClose} />,
    dialogRoot
  );
}
